
import { Coordinate, Geometry } from "jsts/org/locationtech/jts/geom";
import { BufferOp } from "jsts/org/locationtech/jts/operation/buffer";
import { RelateOp } from "jsts/org/locationtech/jts/operation/relate";

//<editor-fold defaultstate="collapsed" desc="config jsts geometry">
Geometry.prototype.buffer = function () {
  return BufferOp.bufferOp(this, ...arguments);
};
Geometry.prototype.intersects = function (g) {
  return RelateOp.intersects(this, g);
}
//</editor-fold>

//<editor-fold defaultstate="collapsed" desc="lodash">
import chain from "lodash/chain";
import value from "lodash/value";
import mixin from "lodash/mixin";
import _ from "lodash/wrapperLodash";
import filter from "lodash/filter";
import find from "lodash/find";
import isArray from "lodash/isArray";
import some from "lodash/some";
import flatten from "lodash/flatten";
mixin(_, {
  chain,
  filter,
  find,
  isArray,
  some,
  flatten
});
_.value = value;
_.prototype.value = value;
//</editor-fold>

const tolernace = 0.5;

class Base {

  constructor(data) {
    this.data = data;
    this.visited = false;
  }
}

class Vertex extends Base {
  
  constructor(tree, coordinate) {
    super();
    this.tree = tree;
    this.edges = [];
    this.coordinate = coordinate;

    if (tree) {
      tree.vertices.push(this);
    }
  }
  
  compare(element) {
    if (_.isArray(element)) {
      element = new Coordinate(...element);
    } else if (element instanceof Vertex) {
      element = element.coordinate;
    } else if (element instanceof Coordinate) {
      
    } else {
      throw 'Zła wartość argumentów';
    }
    //console.log('Vertex - compare', this, element, this.tree.tolernace);
    return this.coordinate.equals2D(element, this.tree.tolernace);
  }
}

class Edge extends Base {
  
  constructor(tree, vertex1, vertex2, data) {
    super(data);
    this.tree = tree;
    this.vertices = [vertex1, vertex2];

    if (tree) {
      vertex1.edges.push(this);
      vertex2.edges.push(this);
      tree.edges.push(this);
    }
  }
  
  compare(element, element2) {
    if (element instanceof Edge) {
      return this.compare(...element.vertices_);
    } else if (arguments.length === 2) {
      if (element instanceof Vertex && element2 instanceof Vertex) {
        return this.compare(element.coordinate, element2.coordinate);
      } else if (element instanceof Coordinate && element2 instanceof Coordinate) {
        //console.log('Edge - compare', this, [element, element2], this.tree.tolernace);
        return (this.vertices[0].coordinate.equals2D(element, this.tree.tolernace) && this.vertices[1].coordinate.equals2D(element2, this.tree.tolernace)) 
                || (this.vertices[1].coordinate.equals2D(element, this.tree.tolernace) && this.vertices[0].coordinate.equals2D(element2, this.tree.tolernace));   
      } else if (_.isArray(element) && _.isArray(element2)) {
        return this.compare(new Coordinate(...element), new Coordinate(...element2));
      }
    }
    
    throw 'Zła wartość argumentów';
  }
  
  getNextEdges() {
    return _.map(this.vertices, vertex => _.filter(this.tree.getEdges(vertex), edge => edge !== this));
  }
}

class Tree extends Base {
  
  constructor(tolernace_opt) {
    super();
    this.tolernace = tolernace_opt || tolernace;
    this.vertices = [];
    this.edges = [];
  }

  findVertexExist(coordinate) {
    if (_.isArray(coordinate)) {
      coordinate = new Coordinate(...coordinate);
    } else if (!(coordinate instanceof Coordinate)) {
      throw 'Zła wartość argumentów';
    }
    return _.find(this.vertices, vertex => vertex.compare(coordinate));
  }

  getOrCreateVertex(coordinate) {
    if (_.isArray(coordinate)) {
      coordinate = new Coordinate(...coordinate);
    } else if (!(coordinate instanceof Coordinate)) {
      throw 'Zła wartość argumentów';
    }
    let vertex = this.findVertexExist(coordinate);
    return vertex ? vertex : new Vertex(this, coordinate);
  }
  
  findEdgeExist(coordinate1, coordinate2) {
    if (_.isArray(coordinate1)) {
      coordinate1 = new Coordinate(...coordinate1);
    } else if (coordinate1 instanceof Vertex) {
      coordinate1 = coordinate1.coordinate;
    } else if (!(coordinate1 instanceof Coordinate)) {
      throw 'Zła wartość argumentów';
    }
    if (_.isArray(coordinate2)) {
      coordinate2 = new Coordinate(...coordinate2);
    } else if (coordinate2 instanceof Vertex) {
      coordinate2 = coordinate2.coordinate;
    } else if (!(coordinate2 instanceof Coordinate)) {
      throw 'Zła wartość argumentów';
    }
    return _.find(this.edges, edge => edge.compare(coordinate1, coordinate2));
  }

  getOrCreateEdge(coordinate1, coordinate2) {
    if (_.isArray(coordinate1)) {
      coordinate1 = new Coordinate(...coordinate1);
    }
    if (_.isArray(coordinate2)) {
      coordinate2 = new Coordinate(...coordinate2);
    }
    
    if (coordinate1 instanceof Coordinate) {
      coordinate1 = this.getOrCreateVertex(coordinate1);
    } else if (!(coordinate2 instanceof Vertex)) {
      throw 'Zła wartość argumentów';
    }
    if (coordinate2 instanceof Coordinate) {
      coordinate2 = this.getOrCreateVertex(coordinate2);
    } else if (!(coordinate2 instanceof Vertex)) {
      throw 'Zła wartość argumentów';
    }
    
    let edge = this.findEdgeExist(coordinate1, coordinate2);
    return edge ? edge : new Edge(this, coordinate1, coordinate2);
  }
  
  getEdges(vertex) {
    return _.filter(this.edges, edge => _.some(edge.vertices, vertex2 => vertex2.compare(vertex)));
  }
  
  findEdges(compare) {
    return _.filter(this.edges, compare);
  }
  findEdge(compare) {
    return _.find(this.edges, compare);
  }
}

export default {
  Vertex,
  Edge,
  Tree
};



// WEBPACK FOOTER //
// ./src/utils/TreeFeatures.js